import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {HeaderComponent} from "./header/header.component";
import {SocialShareModule} from "../social-share/social-share.module";
import {RouterModule} from "@angular/router";
import {SubHeaderComponent} from "./subheader/subheader.component";

@NgModule({
  declarations: [
    HeaderComponent,
    SubHeaderComponent
  ],
  imports: [
    CommonModule,
    SocialShareModule,
    RouterModule
  ],
  exports: [
    HeaderComponent,
    SubHeaderComponent
  ],
  providers: []
})

export class DecoratorModule { }




// WEBPACK FOOTER //
// ./src/app/shared/decorator/decorator.module.ts